import { createContext } from "react";

export const CenteredSwiperContext = createContext<{
	setSelectedSlideIndex: (index: number) => void;
}>({
	setSelectedSlideIndex: () => {},
});
